import React from "react";
import { Toast as BsToast } from "react-bootstrap";

/**
 * Reusable Toast component built on top of react-bootstrap Toast
 * Props:
 * - show: boolean
 * - onClose: function
 * - title: string | ReactNode
 * - subtitle?: string | ReactNode
 * - message?: string | ReactNode
 * - position?: 'absolute' | 'fixed' (default: 'absolute')
 * - zIndex?: number (default: 15)
 * - autohide?: boolean (default: false)
 * - delay?: number (ms, default: 3000) only effective when autohide=true
 * - closeButton?: boolean (default: true)
 * - style?: React.CSSProperties (optional, merged last)
 * - children?: ReactNode (rendered inside body, after message)
 */

const Toast = ({
  show,
  onClose,
  title,
  subtitle,
  message,
  position = 'absolute',
  zIndex = 15,
  autohide = false,
  delay = 3000,
  closeButton = true,
  style = {},
  children,
}) => {

  const baseStyle = {
    position,
    left: 0,
    right: 0,
    top: 0,
    margin: '0 auto',
    backgroundColor: 'rgba(255,255,255,1)',
    border: 'none',
    zIndex,
    maxWidth: 560,
    ...style,
  };

  const headerStyle = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  return (
    <BsToast
      onClose={onClose}
      show={show}
      animation={true}
      autohide={autohide}
      delay={autohide ? delay : undefined}
      style={baseStyle}
    >
      <BsToast.Header closeButton={closeButton} style={headerStyle}>
        <strong className="mr-auto">{title}</strong>
        {subtitle ? <small>{subtitle}</small> : null}
      </BsToast.Header>
      <BsToast.Body>
        {message}
        {children}
      </BsToast.Body>
    </BsToast>
  );
};

export default Toast;

